module.exports = __webpack_public_path__ + "static/media/HealthTech_2.79113a48.gif";